module.exports = __webpack_public_path__ + "static/media/tickets.613456b9.svg";